// @angular/material/autocomplete	Style changes only
// @angular/material/button	        Style changes, API changes
// @angular/material/card	        Style changes only
// @angular/material/checkbox	    Style changes, changes to event behavior
//// @angular/material/chips	        Complete rewrite
//// @angular/material/core	        Style changes only
// @angular/material/dialog	        Style changes, changes to change detection behavior
// @angular/material/form-field	    Style changes, some appearances removed, API changes
// @angular/material/input	        Style changes only
// @angular/material/list	        Style changes, API changes
// @angular/material/menu	        Style changes, API changes
// @angular/material/paginator	    Style changes only
// @angular/material/progress-bar	Style changes only
// @angular/material/progress-spinner	Style changes only
// @angular/material/radio	            Style changes only
// @angular/material/select	            Style changes only
// @angular/material/slide-toggle	    Style changes only
// @angular/material/slider	            Complete rewrite
// @angular/material/snack-bar	        Style changes, API changes
// @angular/material/table	            Style changes only
// @angular/material/tabs	            Style changes, API changes
// @angular/material/tooltip	        Style changes only


import { NgModule } from '@angular/core';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';

import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTableModule } from '@angular/material/table';

// import { MatLegacyAutocompleteModule } from '@angular/material/Legacy-autocomplete';
// import { MatLegacyButtonModule } from '@angular/material/Legacy-button';
// import {MatLegacyCardModule} from '@angular/material/legacy-card';
// import { MatLegacyCheckboxModule } from '@angular/material/Legacy-checkbox';
// import { MatLegacyDialogModule } from '@angular/material/Legacy-dialog';
// import { MatLegacyFormFieldModule } from '@angular/material/Legacy-form-field';
// import { MatLegacyInputModule } from '@angular/material/Legacy-input';
// import { MatLegacyListModule } from '@angular/material/Legacy-list';
// import { MatLegacyMenuModule } from '@angular/material/Legacy-menu';
// import { MatLegacyProgressSpinnerModule } from '@angular/material/Legacy-progress-spinner';
// import { MatLegacyRadioModule } from '@angular/material/Legacy-radio';
// import { MatLegacySelectModule } from '@angular/material/Legacy-select';
// import { MatLegacySlideToggleModule } from '@angular/material/Legacy-slide-toggle';
// import { MatLegacyTableModule } from '@angular/material/Legacy-table';

import { MatExpansionModule } from '@angular/material/expansion';
import { MatDatepickerModule, } from '@angular/material/datepicker';
import { MatDividerModule } from '@angular/material/divider';
import { MatNativeDateModule, DateAdapter, NativeDateAdapter } from '@angular/material/core';
import { MatStepperModule } from '@angular/material/stepper';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatTreeModule } from '@angular/material/tree';
import { CdkTreeModule } from '@angular/cdk/tree';


@NgModule({
    imports: [

        MatAutocompleteModule,
        MatCardModule,
        MatButtonModule,
        MatCheckboxModule,
        MatDialogModule,
        MatFormFieldModule,
        MatInputModule,
        MatListModule,
        MatMenuModule,
        MatProgressSpinnerModule,
        MatRadioModule,
        MatSelectModule,
        MatSlideToggleModule,
        MatTableModule,
        MatTooltipModule,
        MatTreeModule,
        MatToolbarModule,
        MatExpansionModule,
        MatNativeDateModule,
        MatDatepickerModule,
        MatDividerModule,
        MatStepperModule,
        MatGridListModule,
        MatButtonToggleModule
    ],
    exports: [
        MatAutocompleteModule,
        MatCardModule,
        MatButtonModule,
        MatCheckboxModule,
        MatDialogModule,
        MatFormFieldModule,
        MatInputModule,
        MatListModule,
        MatMenuModule,
        MatProgressSpinnerModule,
        MatRadioModule,
        MatSelectModule,
        MatSlideToggleModule,
        MatTableModule,
        MatTooltipModule,
        MatTreeModule,
        CdkTreeModule,
        MatToolbarModule,
        MatIconModule,
        MatExpansionModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatDividerModule,
        MatStepperModule,
        MatGridListModule,
        MatButtonToggleModule
    ],
    providers: [
        {
            provide: DateAdapter, useClass: NativeDateAdapter
        }
    ]
})
export class MaterialModule { }